<template>
  <section class="section" :style="styles">
    <h3>{{ title }}</h3>
    <p v-if="text">
      {{ text }}
    </p>
    <ul v-else>
      <li v-for="(item, key) in list" :key="key">
        <span>{{ key + 1 }}.</span>{{ item }}
      </li>
    </ul>
    <slot></slot>
  </section>
</template>

<script>
export default {
  props: ['title', 'text', 'styles', 'list'],
};
</script>

<style scoped>
.section {
  display: grid;
  margin: 50px 0px;
  --explainer-padding: 0px 10px;
  padding: var(--explainer-padding);
}
h3 {
  justify-self: center;
  width: max-content;
  padding: 2px 10px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 26px;
  font-family: 'Foco';
  color: #2b4047;
  background: #ffdf22;
}
li span {
  color: #ffdf22;
  margin-right: 5px;
}
li {
  color: #2b4047;
}
ul {
  margin-bottom: 2em;
}
p {
  color: #41565d;
  text-align: center;
  font-size: 18px;
  margin-bottom: 30px;
}
@media (min-width: 380px) {
  .section {
    --explainer-padding: 0 20px;
  }
}
</style>
